import { UseFormRegister, FieldValues } from 'react-hook-form';

import Input from '../../../components/form/Input';
import RadioGroupButton from '../../../components/form/RadioGroupButton';
import { IConfigItemType, USER_PROFILE_TAB_OPTIONS } from '../validates/sectionBuilderSchema';

import RenderObjectLabel from './RenderObjectLabel';

export enum USER_PROFILE_TAB_KEYS {
  NEW_ARRIVAL = 'newArrival',
  PROMOTION = 'promotion',
  BEST_SELLER = 'bestSeller',
  BUNDLE = 'bundle',
  PRODUCT_SET = 'productSet',
  EBOOK_COLLECTIONS = 'ebookCollection',
}

export interface IPropsUserProfileItem {
  type: IConfigItemType.UserProfile;
  _id: string;
  tab?: USER_PROFILE_TAB_KEYS;
}

interface IPropsUserProfileSectionItem {
  index: number;
  itemData: IPropsUserProfileItem;
  register: UseFormRegister<FieldValues>;
  expanded?: boolean;
}

const UserProfileSectionItem = (props: IPropsUserProfileSectionItem) => {
  const { index, itemData, register, expanded } = props;

  return (
    <div className="flex justify-between space-x-16">
      <div className="w-full collapse">
        <input type="checkbox" className="peer" defaultChecked={expanded} />
        <div className=" collapse-title bg-systemGrays08FillQuaternary text-systemGrays01LabelPrimary peer-checked:bg-systemGrays08FillQuaternary peer-checked:text-systemGrays01LabelPrimary flex justify-between after:content-['+'] peer-checked:after:content-['-'] ease-out duration-300">
          <span>
            <span>User Profile </span>
            <RenderObjectLabel objectLists={[{ key: 'userId', value: itemData?._id, required: true }]} />
          </span>
        </div>
        <div className="collapse-content text-systemGrays01LabelPrimary peer-checked:bg-systemGrays08FillQuaternary peer-checked:text-systemGrays01LabelPrimary">
          <div className="space-y-8">
            <Input label="userId" name="_id" helperText="Input USER ID" placeholder="userId" register={() => register(`configItems.${index}._id`)} required />
            <RadioGroupButton label="Tab" options={USER_PROFILE_TAB_OPTIONS} register={register} name={`configItems.${index}.tab`} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserProfileSectionItem;
